import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileDown, Upload, ClipboardPaste, Scale, Mail } from "lucide-react";
import {
  LICENSE_CTA_URLS,
  resolveLicenseCtaLabels,
  resolveSupportContactEmail,
} from "@/modules/panelLicenseActivationCtas";

/**
 * Botones de licencia reutilizables (barra del panel y bloque de activación).
 */
export default function PanelLicenseActivationCtaButtons({ systemInfo, showModuleCta = false }) {
  const labels = resolveLicenseCtaLabels(systemInfo);
  const supportEmail = resolveSupportContactEmail(systemInfo);

  return (
    <div className="flex flex-wrap gap-2" data-testid="panel-license-activation-cta-buttons">
      <Button
        asChild
        variant="outline"
        size="sm"
        className="h-9 text-xs font-semibold border-[#0F2D5C] text-[#0F2D5C] bg-white hover:bg-[#0F2D5C]/5"
        data-testid="panel-cta-solicitar-licencia"
      >
        <Link to={LICENSE_CTA_URLS.solicitar()}>
          <FileDown className="w-3.5 h-3.5 mr-1.5" />
          {labels.solicitar}
        </Link>
      </Button>
      <Button
        asChild
        variant="outline"
        size="sm"
        className="h-9 text-xs font-semibold border-emerald-700 text-emerald-900 bg-white hover:bg-emerald-50"
        data-testid="panel-cta-activar-licencia"
      >
        <Link to={LICENSE_CTA_URLS.activar()}>
          <ClipboardPaste className="w-3.5 h-3.5 mr-1.5" />
          {labels.activar}
        </Link>
      </Button>
      {labels.archivoPdf ? (
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-9 text-xs font-semibold border-slate-500 text-slate-800 bg-white hover:bg-slate-50"
          data-testid="panel-cta-archivo-pdf-licencia"
        >
          <Link to={LICENSE_CTA_URLS.archivoPdf()}>
            <Upload className="w-3.5 h-3.5 mr-1.5" />
            {labels.archivoPdf}
          </Link>
        </Button>
      ) : null}
      {showModuleCta ? (
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-9 text-xs font-semibold border-violet-600 text-violet-900 bg-white hover:bg-violet-50"
          data-testid="panel-cta-solicitar-modulo"
        >
          <Link to={LICENSE_CTA_URLS.solicitar()}>
            <Scale className="w-3.5 h-3.5 mr-1.5" />
            {labels.modulo}
          </Link>
        </Button>
      ) : (
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-9 text-xs font-semibold border-slate-400 text-slate-700 bg-white hover:bg-slate-50"
          data-testid="panel-cta-documentos-uso"
        >
          <Link to={LICENSE_CTA_URLS.documentos}>
            <Scale className="w-3.5 h-3.5 mr-1.5" />
            Ver documentos de uso
          </Link>
        </Button>
      )}
      {supportEmail ? (
        <Button
          asChild
          variant="ghost"
          size="sm"
          className="h-9 text-xs font-semibold text-[#0F2D5C]"
          data-testid="panel-cta-contactar-soporte"
        >
          <a href={`mailto:${supportEmail}`}>
            <Mail className="w-3.5 h-3.5 mr-1.5" />
            Contactar soporte / administrador
          </a>
        </Button>
      ) : (
        <p
          className="text-[10px] text-amber-900/80 self-center m-0 w-full sm:w-auto"
          data-testid="panel-cta-soporte-generico"
        >
          Si necesita ayuda, contacte al administrador o distribuidor que le proporcionó el acceso.
        </p>
      )}
    </div>
  );
}
